import {
  useAssignSetting,
  useSetting,
} from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";
import { MIGRATE_CATNAV_FILTERED_COMPONENT_API_TO_LAYOUT_250326 } from "@faire/web-api--source/indigofair/settings/MIGRATE_CATNAV_FILTERED_COMPONENT_API_TO_LAYOUT_250326";

export const useSettingMigrateCatnavToV3LayoutApis = (): boolean => {
  return useSetting(
    MIGRATE_CATNAV_FILTERED_COMPONENT_API_TO_LAYOUT_250326,
    false
  );
};

export const useAssignSettingMigrateCatnavToV3LayoutApis = () =>
  useAssignSetting(MIGRATE_CATNAV_FILTERED_COMPONENT_API_TO_LAYOUT_250326);
